module.exports = __webpack_public_path__ + "img/loading.7f9a6aeb.svg";